export function passkeyErrorMessage(error: unknown, fallback: string): string {
  return error instanceof DOMException && ['NotAllowedError', 'AbortError'].includes(error.name)
    ? 'Face ID / Touch ID was cancelled. You can try again or use an email code.'
    : fallback;
}
